import Vue from "vue";
import moment from "moment";
import "@/utils/VueCurrencyFilter";

Vue.filter("date", date => (date ? moment(date).format("DD.MM.YYYY") : ""));

Vue.filter("datetime", date =>
  date ? moment(date).format("DD.MM.YYYY, HH:mm") : ""
);
